import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PONGOREGISTRATIONMODAL_LEGACY_FIELD_ORDER = [
  { type: 'heading', value: "Comportement" },
  "go_to_u_r_l_on_close",
  "go_to_kiosk_register",
  "active_step",
  { type: 'heading', value: "Couleurs" },
  "action_font_color",
  "action_background_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  pongoRegistrationModalDescriptor: _generatedPongoRegistrationModalDescriptor,
  pongoRegistrationModalModalDefinition,
  pongoRegistrationModalDashboardLayout,
  pongoRegistrationModalConfig,
  pongoRegistrationModalResolveConfig,
  pongoRegistrationModalProperties,
} = doodModalConfig(
  {
    name: "Pongo - Registration modal",
    handle: "pongo-registration-modal",
    internal_name: "PongoRegistrationModal",
    componentType: 'PongoRegistrationModalComponent',
    category: 'modal',
    description: "Pongo - Registration modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "pongo-registration-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    go_to_u_r_l_on_close: propertyValue({
      type: 'link',
      value: '',
      options: {
        "label": "URL de redirection à la fermeture",
        "help": "Choisissez une page ou un point de vente, saisissez une URL externe ou revenez à la page précédente. Laisser vide pour ne pas rediriger.",
        "defaultMode": "page",
        "modes": ["page", "external", "navigationBack"]
      }
    }),
    go_to_kiosk_register: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        "label": "Ouvrir directement l'étape d'inscription kiosk"
      }
    }),
    active_step: propertyValue({
      type: 'select',
      value: "PONGO_STEP_PHONE",
      options: {
        "label": "Étape initiale",
        "choices": [
          {
            "value": "PONGO_STEP_PHONE",
            "label": "Téléphone"
          },
          {
            "value": "PONGO_STEP_KIOSK_CONFIRMATION",
            "label": "Kiosk — confirmation"
          },
          {
            "value": "PONGO_STEP_KIOSK_ACCOUNT_NOT_FOUND",
            "label": "Kiosk — compte introuvable"
          },
          {
            "value": "PONGO_STEP_KIOSK_REGISTER",
            "label": "Kiosk — inscription"
          },
          {
            "value": "PONGO_STEP_KIOSK_REGISTER_CONFIRMATION",
            "label": "Kiosk — confirmation inscription"
          }
        ]
      }
    }),
    action_font_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        "label": "Couleur du texte des actions"
      }
    }),
    action_background_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        "label": "Couleur de fond des actions"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [
              "go_to_u_r_l_on_close",
              "go_to_kiosk_register",
              "active_step",
              "action_font_color",
              "action_background_color",
            ],
          },
        ],
      },
    ],
  })
);

export function pongoRegistrationModalDescriptor(): IBlockDescriptor;
export function pongoRegistrationModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function pongoRegistrationModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPongoRegistrationModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPongoRegistrationModalDescriptor, pongoRegistrationModalProperties, fieldOrder);
}

export {
  pongoRegistrationModalModalDefinition,
  pongoRegistrationModalDashboardLayout,
  pongoRegistrationModalProperties,
  pongoRegistrationModalConfig,
  pongoRegistrationModalResolveConfig,
};

export type PongoRegistrationModalConfig = typeof pongoRegistrationModalConfig;
